import React, { useState, useRef } from "react";
import "./Home.css";
import "./Home-1.css";
import slide_1 from "../assets/Slide_1.jpg";
import slide_2 from "../assets/Slide_2.png";
import nandanam_bg_2 from "../assets/nandanam_bg_2.jpg";
import nandanam_bg_1 from "../assets/nandanam_bg_1.jpg";
import pad_file from "../assets/pad_file.png";
import Modern_slide from "../assets/Modern_slide.webp";
import D_elevation from "../assets/3D_elevation.jpg";
import interior_card_bg from "../assets/interior_card_bg.jpg";
import mep_card_bg from "../assets/mep_card_bg.jpg";
import latest_2nd from "../assets/latest_2nd.png";
import latest_3rd from "../assets/latest_3nd.jpg";
import emailjs from "@emailjs/browser";
import Slider from "react-slick";

import {
  FaCheckCircle,
  FaRoad,
  FaBolt,
  FaTree,
  FaChild,
  FaWater,
  FaLeaf,
  FaHome,
  FaFaucet,
  FaStar,
  FaMapMarkedAlt,
  FaTools,
  FaChartLine,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaPaperPlane,
} from "react-icons/fa";

import {
  MdOutlineDocumentScanner,
  MdOutlinePark,
  MdOutlineNaturePeople,
} from "react-icons/md";

import { GiWaterPipeline, GiTreehouse, GiForestCamp } from "react-icons/gi";
import { PiParkBold } from "react-icons/pi";
const layouts = [
  { name: "Layout A", src: "/gallery/planning/Planning_4.jpg" },
  { name: "Layout B", src: "/gallery/structural/structural_3.png" },
  { name: "Layout C", src: "/gallery/electrical/Electrical_1.jpg" },
];
const statsData = [
  { percent: 80, label: "Completed Property" },
  { percent: 65, label: "Ongoing live Projects" },
  { percent: 50, label: "Investor Satisfaction" },
  { percent: 90, label: "Land Bank Utilization" },
];
const media = [
  {
    id: 1,
    name: "3D Molding and Rendering",
    description: "3D model of the Gplus 1 using SketchUp, followed by high-quality rendering in Lumion 12.5.",
    src: slide_1,
  },
  {
    name: "UPPER Floor Plan Proposal",
    src: latest_2nd,
    description: "2D layout of the Gplus 1, designed using AutoCAD for clear visualization.",
  },
  {
    name: "Site Plan C1",
    src: latest_3rd,
    description: "Premium plots with landscaping, full infrastructure, and eco-zones.",
  },
];

const services = [
  {
    title: "Project Management",
    cardImage: Modern_slide,
    description: "Comprehensive oversight and coordination for successful project delivery.",
  },
  {
    title: "2D & 3D Floor Planning",
    cardImage: slide_1,
    description: "Detailed and creative floor plans for efficient space utilization.",
  },
  {
    title: "Structural Drawing",
    cardImage: slide_2,
    description: "Accurate structural designs ensuring safety and compliance.",
  },
  {
    title: "3D Elevation Drawing",
    cardImage: D_elevation,
    description: "Realistic 3D visualizations to preview your building's exterior.",
  },
  {
    title: "Interior Designs",
    cardImage: interior_card_bg,
    description: "Modern and functional interiors tailored to your lifestyle.",
  },
  {
    title: "MEP Drawings",
    cardImage: mep_card_bg,
    description: "Integrated mechanical, electrical, and plumbing solutions.",
  },
];
const clientReviews = [
  {
    name: "Ravi Teja",
    comment: "This farmland project is amazing and well-organized!",
    video: "https://www.youtube.com/embed/zpOULjyy-n8?rel=0",
  },
  {
    name: "Swapna",
    comment: "Highly recommended! Transparent and reliable.",
    video: "https://www.youtube.com/embed/tgbNymZ7vqY?rel=0",
  },
  {
    name: "Suresh Kumar",
    comment: "A peaceful investment with long-term value.",
    video: "https://www.youtube.com/embed/ysz5S6PUM-U?rel=0",
  },
  {
    name: "Pooja",
    comment: "Excellent service and prime location near river!",
    video: "https://www.youtube.com/embed/xOeZ1LMMzWw?rel=0",
  },
  {
    name: "Mahesh",
    comment: "I loved the plantation work and DTCP layout.",
    video: "https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0",
  },
  // Add more entries similarly
];
const Home = () => {
    const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_t7f9usr",
        "template_h6y98zc",
        form.current,
        "SJmgDa11D5tMkL1Ec"
      )
      .then(() => {
        alert("Message sent successfully!");
        form.current.reset();
        setPopupOpen(false);
        if (selectedLayout) {
          const link = document.createElement("a");
          link.href = selectedLayout.src;
          link.download = selectedLayout.name || "layout";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((error) => {
        alert("Failed to send message. Please try again.");
        console.error("EmailJS Error:", error);
      });
  };

  return (
    <div className="home">
      <div className="container-fluid p-0">
      <div
        id="examCarousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
        data-bs-interval="4000"
      >
        <div className="carousel-inner">

          {/* Slide 1 */}
          <div className="carousel-item active" style={{ position: "relative" }}>
            <img
              src={nandanam_bg_1}
              className="d-block w-100 bg_slide-img"
              alt="Modern Architecture"
            />
            <div className="matter_slide">
              <div className="Slide_1_box text-center">
                <h1>Start your dream with just ₹350/day</h1>
                <p>Own a plot in two prosperous cities</p>
                <div className="slide-buttons">
                  <a href="#venture" className="btn btn-green me-2">Explore Venture</a>
                  <a href="#contact" className="btn btn-outline-gold">Book a Site Visit</a>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2 */}
          <div className="carousel-item" style={{ position: "relative" }}>
            <img
              src={nandanam_bg_2}
              className="d-block w-100"
              style={{ height: "100vh", objectFit: "cover" }}
              alt="Interior Excellence"
            />
            <div className="matter_slide">
              <div className="Slide_2_box text-center">
                <h1>Interior Excellence</h1>
                <p>Transforming spaces with creative, functional, and elegant interior solutions.</p>
                <a href="#gallery" className="btn btn-light slide_button">See Gallery</a>
              </div>
            </div>
          </div>
        </div>

        {/* Carousel Indicators */}
        <div className="carousel-indicators mb-0 justify-content-center">
          {[0, 1].map((index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#examCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#ffd700", // Gold dot
                margin: "0 5px",
                border: "none",
              }}
            />
          ))}
        </div>
      </div>
    </div>

      {/* Riverfront Layout Section */}
<div className="riverfront-section">
    <div className="container-fluid" style={{ padding: '50px' }}>
        <div className="row align-items-center flex-wrap">
          {/* Left Text */}
          <div className="col-lg-5 col-12 text-section">
            <h2>Peaceful<br />Living by<br />the River</h2>
            <p>
              Discover the beauty of nature and modern comforts at<br />
              <span className="highlight">Nandanam Infra – River Front.</span><br />
              Our 50-acre DTCP-approved layout offers ready-to-build plots with great facilities, legal safety, and excellent future value.
            </p>
          </div>

          {/* Right Grid */}
          <div className="col-lg-7 col-12">
            <div className="row features-grid">
              <div className="feature-item">
                <MdOutlineDocumentScanner className="icon" />
                100% Clear Title & Legal Documentation
              </div>

              <div className="feature-item">
                <FaRoad className="icon" />
                30ft Internal Roads & Blacktop Main Roads
              </div>

              <div className="feature-item">
                <FaFaucet className="icon" />
                Electricity, Drainage & Water Pipelines
              </div>

              <div className="feature-item">
                <FaTree className="icon" />
                Avenue Plantation with 7000+ Sandalwood Trees
              </div>

              <div className="feature-item">
                <PiParkBold className="icon" />
                Children’s Park, Swimming Pool & Gym
              </div>

              <div className="feature-item">
                <FaWater className="icon" />
                Riverfront View & Natural Surroundings
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>




      {/* Investment Plans Section */}
     <div className="investment-section-1">
  <div className="container-fluid">
    {/* <div className="investment-header">
      <h2>Affordable Investment Plans Starting at ₹350/day</h2>
      <p>
        Choose from flexible <strong>12-month or 24-month EMI</strong> plans, with <strong>free registration</strong> for upfront payers.
        Get <strong>instant plot confirmation</strong> with just ₹10,000 booking amount.
      </p>
    </div> */}

    <div className="investment-main">
      <div className="investment-cards">
        <div className="investment-card">
          <h2>Flexible Investment Options</h2>
          <p>We offer three flexible investment options tailored to suit different financial preferences.</p>
          <ul>
            <li><strong>₹350/Day Plan:</strong> Start daily investing with 12-month EMI, quick approval, and zero interest—ideal for beginners.</li>
            <li><strong>24-Month Plan:</strong> Extended EMI option, lower monthly payments, flexible schedule, and zero processing fees.</li>
            <li><strong>Full Payment:</strong> One-time payment, free registration, instant plot confirmation, and priority allotment.</li>
          </ul>
        </div>
      </div>

      <div className="investment-image">
        <img src={pad_file} alt="Investment Options Illustration" />
      </div>
    </div>
  </div>
</div>

  
  <div className="abouts-section-1">
    <div className="investment-image abouts-layout">
      <div className="about-box1"></div>
      <img
        src={nandanam_bg_2}
        alt="Family"
        style={{
          position: "absolute",
          bottom: "0px",
          left: "6%",
          top:"7%",
          width: "50%",
          zIndex: 2,
        }}
      />
    </div>

   <div className="about-content">
  <h1>Why Choose Our Properties</h1>
  <h3>Here is a Rare Opportunity to invest in a Lifetime of Happiness</h3>
  <p>
    Lavoura provides a fully secure lifestyle with a plethora of impressive
    amenities — from well-demarcated plots to wide internal roads, from
    beautifully landscaped greens to the latest essential infrastructure.
  </p>

  <ul className="icon-list">
    <li><FaStar className="about-icon" /> Outstanding Property</li>
    <li><FaMapMarkedAlt className="about-icon" /> Modern City Locations</li>
    <li><FaTools className="about-icon" /> Specialist Services</li>
    <li><FaChartLine className="about-icon" /> Market-Leading Research</li>
  </ul>
</div>

</div>

<div className="number-count">
      <h1 className="text-center mb-3">Real Estate by the Numbers</h1>
      <p className="text-center mb-5">In 2023 things look like this percentage</p>

      <div className="row justify-content-center">
        {statsData.map((stat, index) => (
          <div className="col-lg-3 col-md-6 col-sm-6 mb-4" key={index}>
            <div
              className="progress-box1 wow zoomIn"
              data-wow-delay={`${0.2 + index * 0.1}s`}
              style={{
                visibility: "visible",
                animationDelay: `${0.2 + index * 0.1}s`,
                animationName: "zoomIn",
              }}
            >
              <div className="progress-layout">
                <div className="process-circle circle-1"></div>
                <div className="process-circle circle-2"></div>
                <div className="process-circle circle-3"></div>

                <div className="progress-content">
                  <div className="item-parcent">
                    <span className="counterUp" data-counter={stat.percent}>
                      {stat.percent}
                    </span>
                    %
                  </div>
                  <label>{stat.label}</label>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<div className="featured-project-section">
      <div className="featured-project-container">
        {/* Left Side: Image */}
        <div className="featured-image">
          <img src={pad_file} alt="Featured Project" />
        </div>

        {/* Right Side: Details */}
        <div className="featured-details">
  <div className="project-title">
    <h5 style={{ color: '#ffd700' }}>FARMLAND PROJECT</h5>
    <h2 style={{ color: '#400c70' }}>Nandanam River Front</h2>
  </div>

  <h3 className="project-name">Red Sandalwood Farmland @ Krishna River</h3>
  <p className="project-location">
    Near Sree Sailam Highway, 50 Acres DTCP Approved Layout
  </p>

  <div className="project-specs">
    <div>
      <p className="label">PROJECT TYPE</p>
      <strong><FaHome /> Farmland / Open Plots</strong>
    </div>
    <div>
      <p className="label">HIGHLIGHT</p>
      <strong><FaLeaf /> 7000+ Sandalwood Trees</strong>
    </div>
    <div>
      <p className="label">LOCATION</p>
      <strong><FaMapMarkerAlt /> Krishna River Front View</strong>
    </div>
    <div>
      <p className="label">STARTING PRICE</p>
      <strong><FaRupeeSign /> ₹1.25 Lakhs per Gunta</strong>
    </div>
  </div>

  <div className="project-footer">
    <button className="price-btn">₹350/Day Investment Plans</button>
    <div className="project-actions">
      <button className="icon-btn"><FaPhoneAlt /></button>
      <button className="icon-btn"><FaPaperPlane /></button>
    </div>
  </div>
</div>
      </div>
    </div>
 <div className="review-section">
      <div className="review-slider-wrapper">
      <Slider {...settings}>
        {clientReviews.map((review, index) => (
          <div className="review-slide" key={index}>
            {/* Left: Video */}
            <div className="review-video">
              <iframe
                src={review.video}
                title={`Video ${index}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            {/* Right: Comment */}
            <div className="review-comment">
              <h3>{review.name}</h3>
              <p>"{review.comment}"</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    </div>
    </div>
  );
};

export default Home;
